const disallowedFileTypes = ['application/json'];

export default disallowedFileTypes;
